export default "__VITE_ASSET__D9ACE8Th__"